import React, { useState } from 'react';
import GrumpyFuelTank from '../abis/GrumpyFuelTank.json'
import { loadMeowContract } from '../util/StandardGetters.js'
import { renderLocaleTime } from '../util/Utils'
import { fuelTank as fuelTankAddress } from '../util/Addresses'
import NumberFormat from 'react-number-format'

async function loadReclaimData(accounts) {
  const web3 = window.web3;
  const fuelTank = new web3.eth.Contract(GrumpyFuelTank.abi, fuelTankAddress)

  let reclaimable = fuelTank.methods.reclaimableBalances(accounts[0]).call();
  let reclaimStartTime = fuelTank.methods.reclaimStartTime().call();

  const { contract: meow } = await loadMeowContract(accounts);

  let swapEndTime = meow.methods.swapEndTime().call();

  [reclaimable, reclaimStartTime, swapEndTime] =
    await Promise.all([reclaimable, reclaimStartTime, swapEndTime]);

  return {
    fuelTank,
    reclaimable,
    reclaimStartTime,

    meow,
    swapEndTime
  };
}

export const requiredData = {
  name: 'reclaim',
  get: loadReclaimData
}

export default function Reclaim(props) {
  const [ doubleCheck, setDoubleCheck ] = useState(null);
  const { reclaim: r, accounts: [from] } = props;
  const now = (Date.now() / 1000);

  let phase;
  let phaseEnds;

  const reclaimStartTime = r.reclaimStartTime.toNumber()
  const swapEndTime = r.swapEndTime.toNumber();

  if (!reclaimStartTime) {
    phase = 'Swap Window'
    phaseEnds = renderLocaleTime(swapEndTime);
  }
  else if (now < reclaimStartTime) {
    phase = 'Liquidity Harvest'
    phaseEnds = renderLocaleTime(reclaimStartTime);
  }
  else {
    phase = 'Reclaim Period'
    phaseEnds = 'Never'
  }

  const tryReclaim = e => phase === 'Reclaim Period' ?
    reclaimGrumpies() : setDoubleCheck(true)

  const reclaimGrumpies = () =>
    r.fuelTank.methods.reclaimGrumpies().send({from})
  
  return (
    <div className='content-centered'>
      <div className='left-column'>
        <div className='center-row'>
          <small>Current Phase</small>
        </div>
        <div className='center-row'>
          <small>Phase Ends</small>
        </div>
        <div className='center-row'>
          <small>Reclaimable Balance</small>
        </div>
        <div className='center-row'>
          <small>Can reclaim now?</small>
        </div>
      </div>
      <div className='right-column'>
        <div className='center-row'>
          {phase}
        </div>
        <div className='center-row'>
          {phaseEnds}
        </div>
        <div className='center-row'>
        <NumberFormat value={window.web3.utils.fromWei(r.reclaimable.toString(), 'gwei')} displayType={'text'} thousandSeparator={true} /> Grumpy
        </div>
        <div className='center-row'>
          {phase === 'Reclaim Period' ?
            'Yes' : 'No'
          }
        </div>
      </div>
      <div>
        {doubleCheck ?
          <div className='basic-button disabled'>~~~~~</div> :
          <div className='basic-button' onClick={tryReclaim}>{'<-'}</div>
        }
      </div>
      {doubleCheck &&
        <>
          <div>The reclaim phase has not started yet. This transaction will fail.</div>
          <div className='basic-button' onClick={reclaimGrumpies}>{'<-'}</div>
        </>
      }
    </div>
  )
}
